import { StyledComponent } from '@emotion/styled';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const linkWithUnderlineHover = (element: string | StyledComponent<any> = '&', underlineSize = 2, underlineColor = '', underlinePosition = null) => {
  return `
    position: relative;
    ${element}::after {
      content: '';
      position: absolute;
      bottom: ${underlinePosition || `-.${underlineSize}rem`};
      left: 0;
      width: 0;
      border-bottom: .${underlineSize}rem solid ${underlineColor};
      transition: all 0.2s;
    }
    &:active,
    &:hover {
      ${element}::after {
        width: 100%;
      }
    }
  `;
};
